import { FieldConfig } from 'model/deals.model';
import { useEffect, useState } from 'react';
import { DealsService } from 'service/deals.service';
import { BaseDealForm } from '../BaseDealForm';

const BASE_FIELDS: FieldConfig[] = [
  {
    name: 'dealDetails.stageName',
    label: 'Stage',
    type: 'select',
    required: true,
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.buyerType',
    label: 'Buyer type',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  { name: 'dealDetails.organizationName', label: 'Organization name', type: 'text', xs: 12, sm: 6 },
  {
    name: 'dealDetails.qualificationScore',
    label: 'Qualification score',
    type: 'number',
    xs: 12,
    sm: 6,
  },
  { name: 'dealDetails.clientPlacement', label: 'Client placement', type: 'number', xs: 12, sm: 6 },
  { name: 'dealDetails.placedClients', label: 'Placed clients', type: 'text', xs: 12, sm: 6 },
  {
    name: 'dealDetails.engagementType',
    label: 'Engagement type',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  { name: 'dealDetails.developmentFee', label: 'Development fee', type: 'number', xs: 12, sm: 6 },
  { name: 'dealDetails.retainerValue', label: 'Retainer value', type: 'number', xs: 12, sm: 6 },
  { name: 'dealDetails.IPOwnership', label: 'IP Ownership (%)', type: 'number', xs: 12, sm: 6 },
  {
    name: 'dealDetails.lionsgateInvolved',
    label: 'Lionsgate involved',
    type: 'checkbox',
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.recruitingPipeline',
    label: 'Recruiting pipeline',
    type: 'checkbox',
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.revenueTier',
    label: 'Revenue tier',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.ceilingTier',
    label: 'Ceiling tier',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },

  {
    name: 'dealDetails.clientOrientation',
    label: 'Client orientation',
    type: 'select',
    options: [],
    xs: 12,
    sm: 6,
  },
  {
    name: 'dealDetails.careerState',
    label: 'Career stage',
    type: 'select',
    options: [],
    xs: 12,
    sm: 12,
  },
];

export const BrandedEntertainment = () => {
  const [fields, setFields] = useState<FieldConfig[]>(BASE_FIELDS);

  useEffect(() => {
    const fetchDropdowns = async () => {
      try {
        const dealTypeKey = 'BRANDED_ENT';
        const dropdownsData = await DealsService.getDealDropdowns(dealTypeKey);

        const updatedFields = BASE_FIELDS.map((field) => {
          if (field.type === 'select' && field.options) {
            let options: string[] = [];

            switch (field.name) {
              case 'dealDetails.stageName':
                if (dropdownsData.stages && Array.isArray(dropdownsData.stages)) {
                  options = dropdownsData.stages.map((stage: any) => stage.stageName || stage);
                }
                break;
              case 'dealDetails.buyerType':
                if (dropdownsData.buyerType && Array.isArray(dropdownsData.buyerType)) {
                  options = [...dropdownsData.buyerType];
                }
                break;
              case 'dealDetails.engagementType':
                if (dropdownsData.engagementType && Array.isArray(dropdownsData.engagementType)) {
                  options = [...dropdownsData.engagementType];
                }
                break;
              case 'dealDetails.clientOrientation':
                if (
                  dropdownsData.clientOrientation &&
                  Array.isArray(dropdownsData.clientOrientation)
                ) {
                  options = [...dropdownsData.clientOrientation];
                }
                break;
              case 'dealDetails.revenueTier':
                if (dropdownsData.revenueTier && Array.isArray(dropdownsData.revenueTier)) {
                  options = [...dropdownsData.revenueTier];
                }
                break;
              case 'dealDetails.clientFitScore':
                if (dropdownsData.clientFitScore && Array.isArray(dropdownsData.clientFitScore)) {
                  options = [...dropdownsData.clientFitScore];
                }
                break;
              case 'dealDetails.careerStage':
                if (dropdownsData.careerStage && Array.isArray(dropdownsData.careerStage)) {
                  options = [...dropdownsData.careerStage];
                }
                break;
              default:
                options = field.options ? [...field.options] : [];
            }

            return {
              ...field,
              options: options.length > 0 ? options : field.options ? [...field.options] : [],
            };
          }
          return field;
        });

        setFields(updatedFields);
      } catch (error) {
        console.error('Failed to fetch dropdown values:', error);
        setFields(BASE_FIELDS);
      }
    };

    fetchDropdowns();
  }, []);

  return <BaseDealForm fields={fields} />;
};
